import type { ReactNode } from 'react'

import { SectionLabel } from '@/components/px/SectionLabel'

export interface PanelProps {
  heading: string
  children: ReactNode
}

/** A titled card section: a `SectionLabel` header rule above the body. */
export function Panel({ heading, children }: PanelProps) {
  return (
    <section className="rounded-lg border border-border bg-card">
      <div className="flex items-center justify-between gap-3 border-b border-border px-4 py-3">
        <SectionLabel>{heading}</SectionLabel>
      </div>
      <div className="px-4 py-3">{children}</div>
    </section>
  )
}
